import { render } from "./watcher.vue?vue&type=template&id=9791c04a&scoped=true"
import script from "./watcher.vue?vue&type=script&lang=js"
export * from "./watcher.vue?vue&type=script&lang=js"

import "./watcher.vue?vue&type=style&index=0&id=9791c04a&scoped=true&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9791c04a"]])

export default __exports__